import { useQuery } from '@tanstack/react-query';
import { pb } from '@/core/api';
import { useCreatorFilters } from './use-creator-filters';
import { useAuth } from '@/hooks/use-auth';

const ROLE_FIELDS: Record<string, string> = {
  approacher: 'assigned_approacher',
  mago: 'assigned_mago',
  collector: 'collector',
};

function buildQs(
  state: ReturnType<typeof useCreatorFilters.getState>,
  role: string | undefined,
  userId: string | undefined
): string {
  const parts: string[] = [];
  if (role && userId && role !== 'admin') {
    const f = ROLE_FIELDS[role] ?? 'collector';
    parts.push(`roleField=${f}`, `roleId=${encodeURIComponent(userId)}`);
  }
  if (state.category) parts.push(`category=${state.category}`);
  if (state.rank) parts.push(`rank=${state.rank}`);
  if (state.collector) {
    parts.push(`collector=${encodeURIComponent(state.collector)}`);
  }
  if (state.status) {
    parts.push(`status=${encodeURIComponent(state.status)}`);
  }
  if (state.search) {
    parts.push(`search=${encodeURIComponent(state.search)}`);
  }
  return parts.join('&');
}

type SumResponse = { total: number };

export function useFollowersSum(): number | undefined {
  const filters = useCreatorFilters();
  const { user } = useAuth();
  const qs = buildQs(filters, user?.role, user?.id);

  const { data } = useQuery({
    queryKey: ['followers-sum', qs],
    queryFn: async (): Promise<SumResponse> => {
      const url = qs
        ? `/api/leads/followers-sum?${qs}`
        : '/api/leads/followers-sum';
      return pb.send(url, { method: 'GET' });
    },
    staleTime: 30_000,
  });

  return data?.total;
}
